export default {
    selectButton: 'Select',
    resetButton: 'Reset',
    close: 'close',
    title: 'Date range filter',
    options: {
        lastMonth: 'Last month',
        lastWeek: 'Last week',
        lastSevenDays: 'Last 7 days',
        lastThirtyDays: 'Last 30 days',
        lastThreeMonths: 'Last 3 months',
        lastSixMonths: 'Last 6 months',
        lastTwelveMonths: 'Last 12 months',
        userDefined: 'customised'
    }
}
